import React from 'react';
import { useTranslationHook } from 'PyzShopUi/scripts/utils/translationHook';

const productLocalStoreDetailInfo = props => {
    const { store } = props;
    const { translate } = useTranslationHook();

    return (
        <div className="grid-x grid-margin-y padding-top">
            <div className="cell small-12 medium-12 local-store-infos">
                <div className="grid-x">
                    <div className="cell small-2 medium-1">
                        <i className="icon icon-location"></i>
                    </div>
                    <div className="cell small-10 medium-11">
                        <a href={ store.uri } target="_blank">
                            <strong>{ store.title }</strong>
                        </a><br/>
                        { store.street }<br/>
                        { store.zip_code }&nbsp;{ store.city }<br/>
                        {translate('Phone.', { ns: 'search' })}: {store.phone_number}<br />
                        <div className="padding-top">
                            <a href={ store.google_maps_link }
                               target="_blank">
                                <strong>{translate('Route planner', { ns: 'article-detail' })}</strong>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default productLocalStoreDetailInfo;
